import { jsxs as x, jsx as i } from "react/jsx-runtime";
import { A as h, a as m } from "./Avatar-CBn18ztW.js";
import { B as y } from "./Button-DQ5ID5KN.js";
import { c as f } from "./clsx-OuTLNxxd.js";
const g = "320px", d = "600px", r = "1025px", _ = "_isVisuallyHidden_1hfpu_51", u = "_profile_1hfpu_63", p = "_image_1hfpu_67", H = "_name_1hfpu_74", z = "_description_1hfpu_79", b = "_link_1hfpu_80", S = "_details_1hfpu_108", e = {
  mobile: g,
  "mobile-wide": "480px",
  tablet: d,
  "tablet-wide": "800px",
  desktop: r,
  "desktop-mid": "1281px",
  "desktop-large": "1360px",
  "heading-l": "--cxy-fontSize-xxxxl, --cxy-lineHeight-xxl, --cxy-fontWeight-extraBold",
  "heading-l-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-extraBold",
  "heading-m": "--cxy-fontSize-xxxl, --cxy-lineHeight-xxl, --cxy-fontWeight-semiBold",
  "heading-m-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-semiBold",
  "heading-s": "--cxy-fontSize-xxl, --cxy-lineHeight-xl, --cxy-fontWeight-extraBold",
  "subHeading-l": "--cxy-fontSize-xl, --cxy-lineHeight-l, --cxy-fontWeight-bold",
  "subHeading-m": "--cxy-fontSize-l, --cxy-lineHeight-xs, --cxy-fontWeight-normal",
  "subHeading-m-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-light",
  "subHeading-s": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
  "subHeading-s-mobile": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-semiBold",
  "button-m": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
  "button-s": "--cxy-fontSize-s, --cxy-lineHeight-xs, --cxy-fontWeight-semiBold",
  "button-xs": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-normal",
  "text-m": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
  "text-s": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-normal",
  "text-xs": "--cxy-fontSize-xs, --cxy-lineHeight-m, --cxy-fontWeight-semiBold",
  "text-xxs": "--cxy-fontSize-xs, --cxy-lineHeight-xxxs, --cxy-fontWeight-normal",
  isVisuallyHidden: _,
  profile: u,
  image: p,
  name: H,
  description: z,
  link: b,
  "layout-column": "_layout-column_1hfpu_101",
  "layout-row": "_layout-row_1hfpu_105",
  details: S,
  "size-s": "_size-s_1hfpu_115",
  "size-m": "_size-m_1hfpu_120",
  "size-l": "_size-l_1hfpu_131"
}, v = ({
  name: l,
  image: s,
  description: n,
  layout: c = "column",
  profileLink: t,
  size: a = "m",
  ...o
}) => /* @__PURE__ */ x(
  "div",
  {
    ...o,
    className: f(
      e.profile,
      e[`size-${a}`],
      e[`layout-${c}`],
      o.className
    ),
    children: [
      /* @__PURE__ */ i(h, { className: e.image, children: /* @__PURE__ */ i(m, { alt: `Image of ${l}`, src: s }) }),
      /* @__PURE__ */ x("div", { className: e.details, children: [
        /* @__PURE__ */ i("h3", { className: e.name, children: l }),
        n && /* @__PURE__ */ i("p", { className: e.description, children: n }),
        t && /* @__PURE__ */ i(y, { variant: "ghostBrand", className: e.link, asChild: !0, children: /* @__PURE__ */ i("a", { href: t.href, children: t.text }) })
      ] })
    ]
  }
);
export {
  v as P
};
